/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Preview_TitleInputs */

const en_project_preview_title = /** @type {(inputs: Project_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project preview`)
};

const lv_project_preview_title = /** @type {(inputs: Project_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekta priekšskatījums`)
};

/**
* | output |
* | --- |
* | "Project preview" |
*
* @param {Project_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_preview_title = /** @type {((inputs?: Project_Preview_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Preview_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_preview_title(inputs)
	return en_project_preview_title(inputs)
});